import { Checkbox, FormControl, FormLabel, Link, Text } from "@chakra-ui/react";
import React from "react";
import { remCalc } from "theme/utils";

type GdprOptInProps = {
  name: string;
  color?: string;
  onChange: (event: any) => void;
};

export function GdprOptIn({ name, onChange }: GdprOptInProps) {
  return (
    <FormControl as="fieldset" id="gdpr" maxW={remCalc(515)}>
      <FormLabel as="legend" opacity={0} height={0} m={0}>
        Notice and consent / legitimate interest (GDPR)
      </FormLabel>

      <Checkbox name={name} alignItems="flex-start" mt="smallest" textStyle="caption1" onChange={onChange}>
        <Text textStyle="caption1">I agree to receive communications from Hightouch.</Text>
      </Checkbox>

      <Text textStyle="caption2" mt="smallest">
        By submitting this form, you understand Hightouch will process your personal information in accordance with our{" "}
        <Link variant="inlineDark" href="/privacy-policy">
          Privacy Policy
        </Link>
        .
      </Text>
    </FormControl>
  );
}
